import {observer} from "mobx-react";
import {useState} from "react";
import {ReceiptsChart} from "./ReceiptsChart";
import {ReceiptTable} from "./ReceiptTable";
import {kpiReceiptStore} from "../../../store/kpi/KpiReceiptStore";
import {ReceiptTypeDto} from "../../../api/kpi";

interface ReceiptsProps {
    title: string
    mode: 'document' | 'record'
}

const Receipts = observer(function Receipts({
                                                mode,
                                                title
                                            }: ReceiptsProps) {
    const [tab, setTab] = useState<'chart' | 'table'>('chart')
    const data = mode === 'document' ? kpiReceiptStore.documentData : kpiReceiptStore.recordData
    const chartData = mode === 'document' ? kpiReceiptStore.documentChartData : kpiReceiptStore.recordChartData
    const types:ReceiptTypeDto[] = mode === 'document'
        ? [ReceiptTypeDto.SCAN_COMPLETE, ReceiptTypeDto.ACQUISITION_COMPLETE, ReceiptTypeDto.PLACEMENT_COMPLETE]
        : [ReceiptTypeDto.SCAN_RECORD_COMPLETE, ReceiptTypeDto.ACQUISITION_RECORD_COMPLETE, ReceiptTypeDto.PLACEMENT_RECORD_COMPLETE]
    const prefix = mode === 'document' ? '' : 'Akte '
    return <>
        <div className="card">
            <header className="card-header">
                <p className="card-header-title">{title}</p>
            </header>
            <div className="tabs is-boxed is-small" style={{marginBottom: '0'}}>
                <ul>
                    <li className={tab === 'chart' ? 'is-active' : ''}>
                        <a href={'#chart'} onClick={e => {
                            e.preventDefault()
                            setTab('chart')
                        }}>
                            <span className="material-symbols-outlined">bar_chart_4_bars</span>
                            <span>Total</span>
                        </a>
                    </li>
                    <li className={tab === 'table' ? 'is-active' : ''}>
                        <a href={'#chart'} onClick={e => {
                            e.preventDefault()
                            setTab('table')
                        }}>
                            <span className="material-symbols-outlined">table</span>
                            <span>Detail</span>
                        </a>
                    </li>
                </ul>
            </div>
            <div style={{height: '20em', display: 'flex'}}>
                {tab === 'chart' && <ReceiptsChart prefix={prefix} chartData={chartData} types={types}/>}
                {tab === 'table' && <ReceiptTable data={data}/>}
            </div>
        </div>
    </>
})

export {
    Receipts
}

